module.exports = __webpack_public_path__ + "img/gumroad-logo-png_seeklogo-431430.954044e5.png";